{
  "loading": "読み込み中...",
  "placeholder": "選択…"
}
